import mapleIntegrationService from '../services/maple-integration-service';
import authService from '../services/auth-service';
import type { AuthState } from '../store/reducers/auth';
import type { Action } from '../types/actions';
import { reLoadAuth, authenticate, setTfaChallenge, setFormErrors } from './auth';
import userActions from '../actions/user';

type Dispatch = (action: Action | ThunkAction | PromiseAction) => any;
type PromiseAction = Promise<Action>;
type GetState = () => {
  auth: AuthState,
  user: any,
};
type ThunkAction = (dispatch: Dispatch, getState: GetState) => any;

function connectFailure(error): Action {
  return {
    type: 'MAPLE_CONNECT_ERROR',
    error
  };
}

function connect(): Action {
  return {
    type: 'MAPLE_CONNECT'
  };
}

function authSuccess(): Action {
  return {
    type: 'MAPLE_AUTH_SUCCESS'
  };
}

function connectSuccess(): Action {
  return {
    type: 'MAPLE_CONNECT_SUCCESS'
  };
}

export function login(email: string, password: string, tfaToken: ?string, remember: boolean): ThunkAction {
  return ((dispatch) => {
    dispatch(reLoadAuth());
    authService.login(email, password, tfaToken, remember)
      .then((data) => {
        if (data.access_token) {
          dispatch(authenticate());
          dispatch(authSuccess());
        } else if (data.tfa_enabled) {
          dispatch(setTfaChallenge());
        }
      })
      .catch((error) => {
        if (error && error.length > 0 && (error[0].code === '2fa_required')) {
          dispatch(setTfaChallenge());
        } else {
          dispatch(setFormErrors(error));
        }
      });
  });
}

export function signup(email: string, password: string): ThunkAction {
  return ((dispatch) => {
    dispatch(reLoadAuth());
    return authService.signup(email, password)
      .then(() => {
        dispatch(authenticate());
        dispatch(userActions.createUser(email, false));
      })
      .catch((error) => dispatch(setFormErrors(error)));
  });
}

export function authorizeMaple(params: string): ThunkAction {
  return ((dispatch) => {
    dispatch(connect());
    mapleIntegrationService.authorizeMaple(params)
      .then((data) => {
        dispatch(connectSuccess());
        const { url } = data;
        window.location.href = url;
      })
      .catch((error) => {
        dispatch(connectFailure(error));
      });
  });
}

export default authorizeMaple;



// WEBPACK FOOTER //
// ./src/actions/maple-login.js